import React from "react";
import { Col, Row, CardBody, Label } from "reactstrap";
import { DebouncedFunc } from "lodash";
import { useFormContext, Controller } from "react-hook-form";
import { RoleDtoCodeEnum, UserDtoStatusEnum } from "generated/apiUsers";
import Select from "react-select";
import { useTranslation } from "react-i18next";

interface UserFilterProps {
  debounceFn: DebouncedFunc<(value: any) => void>;
}

const STATUS_USER: any = [
  {
    options: [
      { label: "All", value: undefined },
      { label: "Active", value: UserDtoStatusEnum.Active },
      { label: "Inactive", value: UserDtoStatusEnum.Inactive },
    ],
  },
];

const ROLE_USER: any = [
  {
    options: [
      { label: "All", value: undefined },
      { label: "Superadmin", value: RoleDtoCodeEnum.Superadmin },
      { label: "Manager", value: RoleDtoCodeEnum.Manager },
      { label: "Caregiver Professionale", value: RoleDtoCodeEnum.CaregiverProfessional },
      { label: "Caregiver Familiare", value: RoleDtoCodeEnum.CaregiverUser },
    ],
  },
];

const UserFilter: React.FC<UserFilterProps> = ({ debounceFn }) => {
  const { t } = useTranslation("translation", { keyPrefix: "USERS" });
  const { control } = useFormContext();

  return (
    <React.Fragment>
      <CardBody className="border border-dashed border-end-0 border-start-0">
        <Row>
          <Col sm={4} className="col-xxl-1">
            <div className="d-flex gap-1 flex-wrap">
              <button type="button" className="btn btn-primary w-100">
                {" "}
                <i className="ri-equalizer-fill me-1 align-bottom"></i>
                {t("LAYOUT:FILTERS")}
              </button>
            </div>
          </Col>
        </Row>

        <Row className="mt-3">
          <Col sm={5}>
            <div className={"search-box me-2 mb-2 d-inline-block col-12"}>
              <Controller
                name="search"
                control={control}
                defaultValue=""
                render={({ field: { onChange, value } }) => (
                  <>
                    <Label htmlFor="" className="form-label">
                    {t("DETAILS:FILTERS:SEARCH")}
                    </Label>
                    <input
                      id="search"
                      className="form-control"
                      placeholder="Search..."
                      value={value}
                      onChange={(e) => {
                        onChange(e);
                        debounceFn(e.target.value);
                      }}
                    />
                  </>
                )}
              />

            </div>
          </Col>
          <Col sm={4} className="col-xxl-2">
            <div>
              <Controller
                control={control}
                name="status"
                render={({ field }) => (
                  <>
                    <Label htmlFor="" className="form-label">
                    {t("DETAILS:FILTERS:STATUS")}
                    </Label>
                    <Select {...field} options={STATUS_USER} />
                  </>
                )}
              />
            </div>
          </Col>
          <Col sm={4} className="col-xxl-2">
            <div>
              <Controller
                control={control}
                name="role"
                render={({ field }) => (
                  <>
                    <Label htmlFor="" className="form-label">
                    {t("DETAILS:FILTERS:ROLE")}
                    </Label>
                    <Select {...field} options={ROLE_USER} />
                  </>
                )}
              />
            </div>
          </Col>
          <Col sm={4} className="col-xxl-4">
            <div></div>
          </Col>
        </Row>
      </CardBody>
    </React.Fragment>
  );
};
export default UserFilter;
